import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'
import dayjs from 'dayjs'

export async function list() {
  return httpClient.get('career/list').then(handleSuccess).catch(handleError)
}

export async function create(formData) {
  const params = new URLSearchParams()
  params.append('name', formData.name)
  params.append('position', formData.position)
  params.append('type', formData.type)
  params.append('started_at', dayjs(formData.started_at).format('YYYY/MM/DD'))
  if (formData.ended_at) {
    params.append('ended_at', dayjs(formData.ended_at).format('YYYY/MM/DD'))
  }

  return httpClient.post('career/create', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function update(formData) {
  const params = new URLSearchParams()
  params.append('name', formData.name)
  params.append('position', formData.position)
  params.append('type', formData.type)
  params.append('started_at', dayjs(formData.started_at).format('YYYY/MM/DD'))
  if (formData.ended_at) {
    params.append('ended_at', dayjs(formData.ended_at).format('YYYY/MM/DD'))
  } else {
    // nullで渡すとバリデーションチェック時に"null"になってしまうので空文字を渡す
    params.append('ended_at', '')
  }
  params.append('id', formData.id)
  params.append('user_id', formData.user_id)

  return httpClient.post('career/update', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function _delete(careerId) {
  const params = new URLSearchParams()
  params.append('id', Number(careerId))

  return httpClient.post('career/delete', params, apiHeader).then(handleSuccess).catch(handleError)
}
